import * as React from 'react';
import { WithT } from 'i18next';
import classNames from 'classnames';
import { UserAvatar, IColumn } from 'components';
import { formatPhoneNumber } from 'helpers';
import { IUser } from 'modules/admin-panel/models';

export function generateColumns(t: WithT['t']): IColumn[] {
	return [
		{
			name: 'avatar',
			label: '',
			cellRenderer: (data: IUser) => {
				return (
					data.profilePictureUrl && (
						<UserAvatar
							avatarClass="user-avatar_small"
							photo={data.profilePictureUrl}
						/>
					)
				);
			},
			hideHeader: true,
			marginRight: 16,
		},
		{
			name: 'name',
			label: <p>{t('table.name')}</p>,
			cellRenderer: (data: IUser) => {
				return <p>{`${data.firstName} ${data.lastName}`}</p>;
			},
		},
		{
			name: 'status',
			label: <p>{t('table.status')}</p>,
			cellRenderer: (data: IUser) => {
				return (
					<p
						className={classNames({
							'font-secondary': !data.isActive,
						})}
					>
						{data.isActive ? t('active') : t('inactive')}
					</p>
				);
			},
		},
		{
			name: 'phone',
			label: <p>{t('table.phone')}</p>,
			cellRenderer: (data: IUser) => {
				return <p>{formatPhoneNumber(data.phone)}</p>;
			},
		},
		{
			name: 'email',
			label: <p>{t('table.email')}</p>,
			cellRenderer: (data: IUser) => {
				return <p>{data.email}</p>;
			},
		},
	];
}
